import { Form, Input, message } from "antd";
import { Api } from "../../../../../api/configApi";
import Boton from "../../../../../components/design/elementos/boton";

function IntegracionCoinpayments(values) {
  function guardar(values) {
    Api(
      "Cuentas",
      "InsertIntegracion",
      { tipoIntegracion: "pasarelas", proveedor: "coinpayments" },
      values
    ).then((res) => {
      if (res.success) {
        message.success("Integración Coinpayments guardada");
      } else {
        message.error("Algo no salio bien.");
      }
    });
  }
  return (
    <Form onFinish={guardar} layout="vertical">
      <Form.Item
        rules={[{ required: true, message: "campo obligatorio" }]}
        label="Public Key"
        name="key"
      >
        <Input />
      </Form.Item>
      <Form.Item
        rules={[{ required: true, message: "campo obligatorio" }]}
        label="Private Key"
        name="secret"
      >
        <Input.Password />
      </Form.Item>

      <Boton texto="Guardar" htmlType="submit" />
    </Form>
  );
}

export default IntegracionCoinpayments;
